import { render, staticRenderFns } from "./NewsManage.vue?vue&type=template&id=68961537&scoped=true&"
import script from "./NewsManage.vue?vue&type=script&lang=js&"
export * from "./NewsManage.vue?vue&type=script&lang=js&"
import style0 from "./NewsManage.vue?vue&type=style&index=0&id=68961537&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68961537",
  null
  
)

export default component.exports